import { FUNDING_CATEGORY, PAYMENT_METHOD_TYPES } from '../store/interface';

export const PAYMENT_METHODS_WALLET: { [key: string]: PAYMENT_METHOD_TYPES } = {
  BANK: 'BANK ACCOUNT',
  CARD: 'CARD',
};

export const FUNDING_CATEGORIES: { [key: string]: FUNDING_CATEGORY } = {
  CHECK: 'Check',
  CREDIT: 'Credit',
  DEBIT: 'Debit',
};

export const MONTHS_LIST = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
];

export type WALLET_PAYMENT_CARD_ACTIONS = 'ADD' | 'EDIT' | 'DELETE';

export const ZIPCODE_LENGTH = 5;

export const NICKNAME_MIN_LENGTH = 1;
export const NICKNAME_MAX_LENGTH = 30;

export const WALLET_STATUS_CODES = {
  SUCCESS: 'Success',
  CREATED: 'Created',
};
